module.exports = __webpack_public_path__ + "assets/img/tech-5.2eb07070.svg";